import { createContext } from 'react';
import { IBmoTransaction } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';

export interface IBmoTransactionsTableContext {
    date: null | string;
    bmoTransactions: IBmoTransaction[];
    bmoTransactionsLoading: boolean;
    transactionTypes: string[];
    paginationOptions: PaginationOptions | null;
    bmoReconciledStatus: string;
    bmoDebitCreditStatus: string;
    onBmoTransactionViewClick: (bmoTransaction: IBmoTransaction) => void;
    setDate: (date: string) => void;
    setBmoReconciledStatus: (bmoReconciledStatuses: string) => void;
    setBmoDebitCreditStatus: (bmoDebitCreditStatuses: string) => void;
    setSearchString: (search: string) => void;
    setTransactionTypes: (transactionTypes: string[]) => void;
}

export const BmoTransactionsTableContext = createContext<IBmoTransactionsTableContext>({
    date: null,
    bmoTransactions: [],
    bmoTransactionsLoading: false,
    bmoReconciledStatus: '',
    bmoDebitCreditStatus: '',
    paginationOptions: null,
    transactionTypes: [],
    onBmoTransactionViewClick: emptyFunc,
    setDate: emptyFunc,
    setBmoReconciledStatus: emptyFunc,
    setBmoDebitCreditStatus: emptyFunc,
    setSearchString: emptyFunc,
    setTransactionTypes: emptyFunc,
});
